/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import "./applyCoupon.scss";
import to from "await-to-js";
import UKToast from "@/common-components-src/components/UKToast/index";
import JDILogin from "@/common-components-src/js/newlogin/index.newlogin";
import {
  fetchCouponDetail,
  fetchOrCancelCoupon,
  fetchPromocodeDetail,
  fetchuseOrCancelCouponCode,
} from "@/app/csr-src/apis/coupon/coupon.api";
import {
  Alert,
  Button,
  Radio,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  FormHelperText,
  FilledInput,
} from "@mui/material";
import NoCouponData from "./noCouponData";
import More from "@/app/csr-src/assets/icons/more.svg";
import Expand from "@/app/csr-src/assets/icons/chevron-down.svg";
import CloseIcon from "@/app/csr-src/assets/icons/close.svg";
import CouponClose from "@/app/csr-src/assets/icons/couponClose.svg";
import { FEACH_PARAMS, USERBESTCOUPON } from "./constant";
import { ACTION_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";
import Closed from "@/app/csr-src/assets/icons/Closed.svg";
import { sendClickTrack } from "@/tracks/25281";
import { string } from "mobx-state-tree/dist/internal";
import { useTranslation } from "react-i18next";
interface ApplyCouponProps {
  onFresh?: (res: {
    type: string; // 优惠券：'coupon' 优惠码：'code'
    data: any;
    refreshOrderSource: "saveCoupon";
  }) => void;
  immediatelyBuy?: boolean;
  actionType?: string; // ACTION_TYPE.ADDRESS | ACTION_TYPE.CART
}
export default function ApplyCoupon(props: ApplyCouponProps) {
  const { t } = useTranslation();
  type floorsProps = {
    type: {
      namespace: string;
    };
    info: {
      "C-M#couponSingleFloor&core": object;
      "C-M#couponSingleFloor&discount": object;
      "C-M#couponSingleFloor&limitUseInfo": {
        couponStyle: number;
      };
      "C-M#couponSingleFloor&time": object;
      "CYBB2C-D#basicMsg&basicMsg": object;
      "VCYBB2C-D#money&money": object;
      "VCYBB2C-D#couponCode&basic"?: object;
    };
    uuid: string | null;
  };
  type detail = {
    promoCode?: string;
    discount?: number;
    quota?: number;
    promoCodeId?: number;
    activityId?: string;
  };
  interface couponItems {
    couponDiscount?: string;
    limitDesc?: string;
    timeEnd?: string;
    couponLimitInfo?: string;
    key?: string;
    canUsed?: boolean;
    promoCode?: string;
    discount?: string;
    discountStr?: number;
    quota?: number;
    quotaStr?: string;
    label?: string;
    selected?: boolean;
    id?: string;
    couponType?: number;
    couponStyle?: number;
    activityId?: number;
    batchId?: number;
  }
  type couponType = {
    available?: Array<couponItems> | [];
    notavailable?: Array<couponItems> | [];
  };
  type fetchJson = {
    orderStr: object | null;
    immediatelyBuy?: boolean | undefined;
    verticalTag: string;
    clientVersion: string;
    client: string;
    lang: string;
    isPresale: boolean;
    ptFlag: boolean;
  };
  const CODE_STYLE = 39; // code标识
  const [selected, setSelected] = useState < string > ("available");
  const [isOpen, setIsOpen] = useState < string > ("expand");
  const [applyCode, updateApplyCode] = useState < string > ("");
  const [error, setError] = useState < string | null > (null);
  const [couponDetails, setcouponDetails] = useState < couponItems[] > ([]);
  const [couponListData_available, setcouponListData_available] = useState < couponItems[] > ([]);
  const [couponListData_notavailable, setcouponListData_notavailable] = useState < couponItems[] > ([]);
  const [currentData, setCurrentData] = useState < couponItems[] > ([]);
  const [codeDetail, setCodeDetail] = useState < couponItems[] > ([]);
  const [codeCheck, setCodeCheck] = useState < boolean > (true);
  const [codeError, setCodeError] = useState < string > ("");
  const [isCardOpen, setIsCardOpen] = useState < string > ("expanddown");
  const [currentId, setCurrentId] = useState < number > ();
  const [currentKey, setCurrentKey] = useState < number > (0);
  const [currentHeight, setCurrentHeight] = useState < string > ("108px");
  const handleTabChange = (tab: string) => {
    console.log("tab------", couponListData_available, couponListData_notavailable);
    setSelected(tab);
    setIsOpen("expand");
    setCurrentHeight("108px");
    setIsCardOpen("expanddown");
    if (tab === "available") {
      setCurrentData(couponListData_available);
    } else {
      setCurrentData(couponListData_notavailable);
    }

    const arr = getTrackCouponList(tab === "available" ? couponListData_available : couponListData_notavailable);
    sendClickTrack.SettleAccounts_OrderNew_CouponLayerTab({
      tabName: tab,
      coupon: arr as any,
    })
  };


  /** 获取当前tab下所有的券/码 */
  const getTrackCouponList = (listArr: any[]) => {
    const selectedItem = codeDetail?.length ? codeDetail[0] : null;
    const list = [...listArr];
    if (selectedItem && selectedItem.id && list.filter((v: any) => v.id === selectedItem.id)?.length === 0) {
      list.push({
        id: "",
        batchId: "",
        quota: selectedItem.quota,
        couponType: selectedItem.couponType,
        discount: selectedItem.discount,
      });
    }

    return list?.map((coupon: any) => {
      return {
        couponId: coupon.id || "-100",
        batchId: coupon.batchId || "-100",
        use_threshold: coupon.quota ? String(coupon.quota) : "-100",
        couponType: coupon.couponType ? String(coupon.couponType) : "-100",
        // 取不到
        couponTag: "-100",
        couponSave: coupon.discount ? String(coupon.discount) : "-100",
      }
    });
  }

  // 批量 - 选中、取消优惠券
  // const handdleCancelCouponMount = async () => {
  //   /*
  //     /* 1、选中优惠券 取消选中的口令券 
  //     /* 2、取消优惠券 (判断是否同时有其它选中的优惠券)
  //     /*  2-1 无选中的优惠券 
  //     /*    a  有口令券 默认选中口令券
  //     /*    b  无口令券 直接取消优惠券
  //     /*  2-2  有选中的优惠券 直接取消优惠券
  //     */
  //   // const { selected, key, id } = couponListData_available;
  //   const theCoupons: Array<couponItems> = [];
  //   couponListData_available.forEach((v) => {
  //     const { key, id } = v;
  //     theCoupons.push({
  //       selected: false, // 取消选中
  //       key,
  //       id,
  //     });
  //   });
  //   const params = {
  //     orderStr: {
  //       useBestCoupon: USERBESTCOUPON, // 是否展示‘使用最优推荐’按钮
  //       theCoupons,
  //     },
  //     ...FEACH_PARAMS,
  //     immediatelyBuy: props.immediatelyBuy,
  //   };
  //   const [err, res] = await to(fetchOrCancelCouponMount(params));
  //   if (res?.code !== "200") {
  //     UKToast.show({
  //       content: res?.msg,
  //       icon: "error",
  //     });
  //   } else {
  //     UKToast.show({
  //       content: "success",
  //       icon: "success", // 可选：success, fail, loading, warn, info，影响图标
  //     });
  //     // 更新券列表
  //     getOrderDetails();
  //   }
  // };
  const handleToggleChange = () => {
    if (isOpen === "expand") {
      setIsOpen("close");
      setCurrentHeight("auto");
    }
    if (isOpen === "close") {
      setIsCardOpen("expanddown");
      setIsOpen("expand");
      setCurrentHeight("108px");
      // if(isCardOpen === 'expanddown'){
      //   setCurrentHeight('100px')
      // }else{
      //   setCurrentHeight('120px')
      //   // setCurrentHeight('auto')
      // }
    }
  };
  // 请求选中 取消口令券
  const fetchUseOrCancelCouponCode = async (params: any) => {
    const [err, res] = await to(fetchuseOrCancelCouponCode(params));
    if (res?.code !== "200") {
      UKToast.show({
        content: res?.message,
        icon: "error",
      });
    } else {
      UKToast.show({
        content: t("common.pageStatus.success"),
        icon: "success",
      });
      const { floors } = res.data;
      // 更新券列表
      dealResDate(floors);
      props?.onFresh!({
        type: "code",
        data: null,
        refreshOrderSource: "saveCoupon",
      });
    }
  };

  // 选中取消口令券 （ 口令券和优惠券二选一 ）
  const handleUseOrCancelCouponCode = async (event: React.MouseEvent<Element, MouseEvent>) => {
    // const target = event.target as HTMLInputElement;
    // const { checked } = target;
    const checked = !codeDetail[0]?.selected;
    setCodeCheck(checked);
    let orderStr = {};
    if (checked) {
      orderStr = {
        couponCode: applyCode,
        selected: checked,
      };
    } else {
      orderStr = {
        couponCode: applyCode,
        selected: checked,
        batchId: codeDetail[0]?.batchId ? codeDetail[0].batchId.toString() : null,
        activityId: codeDetail[0]?.activityId ? codeDetail[0].activityId : null,
      };
    }
    const params = {
      orderStr,
      ...FEACH_PARAMS,
      immediatelyBuy: props.immediatelyBuy,
    };
    fetchUseOrCancelCouponCode(params);
  };
  //  查询口令券
  const handleSearchApplyCode = async () => {
    // 请求接口检查code码有效性 TODO
    // The code you entered is invalid
    // 检测是否输入CODE码
    if (!applyCode) {
      return;
    }
    // 查看是否登录
    const { isLoggedIn } = await JDILogin.getInstance().getUserInfo();
    if (!isLoggedIn) {
      JDILogin.getInstance().openLoginDialog();
    } else {
      getPromocodeDetail();
    }
  };
  // 处理优惠券接口数据
  const dealResDate = (floors: Array<floorsProps>) => {
    console.log("floors 总数据======", floors);
    const couponList: Array<couponItems> = [];
    const codeList: Array<couponItems> = [];
    floors?.length &&
      floors.forEach((v: floorsProps) => {
        const { type, info } = v;
        if (type?.namespace === "core.trade-FLR#balance.coupon-M#couponSingleFloor") {
          const data = {
            ...info["C-M#couponSingleFloor&core"],
            ...info["C-M#couponSingleFloor&discount"],
            ...info["C-M#couponSingleFloor&limitUseInfo"],
            ...info["C-M#couponSingleFloor&time"],
            ...info["CYBB2C-D#basicMsg&basicMsg"],
            ...info["VCYBB2C-D#money&money"],
            ...info["VCYBB2C-D#couponCode&basic"],
          };
          if (info["C-M#couponSingleFloor&limitUseInfo"]?.couponStyle === CODE_STYLE) {
            codeList.push(data);
          } else {
            couponList.push(data);
          }
        }
      });
    console.log("codeList 码列表======", codeList);
    // 分堆 （ 可用优惠券 ｜ 不可用优惠券 ）
    const available_list: Array<couponItems> = [];
    const not_available_list: Array<couponItems> = [];
    let currentData_total: Array<couponItems> = [];
    couponList.forEach((v) => {
      if (v && v.canUsed) {
        available_list.push(v);
      } else {
        not_available_list.push(v);
      }
    });
    console.log("selected=====", selected);
    if (selected === "available") {
      currentData_total = available_list;
      // setCurrentData(available_list)
    } else {
      currentData_total = not_available_list;
      // setCurrentData(not_available_list)
    }
    setCodeDetail(JSON.parse(JSON.stringify(codeList)));
    setcouponDetails(couponDetails);
    setcouponListData_available(available_list);
    setcouponListData_notavailable(not_available_list);
    setCurrentData(currentData_total);
    console.log("available_list=====", available_list);
    console.log("not_available_list=====", not_available_list);
    console.log("currentData=====", currentData);
  };
  // 调优惠券接口
  const searchancelCoupon = async (params: fetchJson) => {
    const [err, res] = await to(fetchOrCancelCoupon(params));
    if (res.resultCode === "C-DM@60-CD@1.100000") {
      UKToast.show({
        content: t("common.pageStatus.success"),
        icon: "success",
      });
      const { floors } = res.data;
      // 更新券列表
      dealResDate(floors);
      // 通知主页刷新数据
      props?.onFresh!({
        type: "coupon",
        data: null,
        refreshOrderSource: "saveCoupon",
      });
    } else {
      UKToast.show({
        content: res.message, // 弹窗内容
        icon: "error",
      });
    }
  };
  // 查询优惠券列表
  const getOrderDetails = async () => {
    const requestData = {
      orderStr: {
        useBestCoupon: USERBESTCOUPON,
      },
      ...FEACH_PARAMS,
      immediatelyBuy: props.immediatelyBuy,
    };
    const [err, res] = await to(fetchCouponDetail(requestData));
    if (err) {
      UKToast.show({
        content: err, // 弹窗内容
        icon: "error", // 可选：success, fail, loading, warn, info，影响图标
      });
      setcouponDetails([]);
    } else {
      // 取出优惠券数据
      const { floors } = res.data;
      dealResDate(floors);
    }
  };
  // 查询口令券
  const getPromocodeDetail = async () => {
    const requestData = {
      promoCode: applyCode,
      ...FEACH_PARAMS,
      immediatelyBuy: props.immediatelyBuy,
    };
    const [err, res] = await to(fetchPromocodeDetail(requestData));
    console.log("res码=======", res?.code, res);
    if (res?.code !== "200") {
      setCodeError(res?.msg);
      // setCodeDetail([]);
      sendClickTrack.SettleAccounts_OrderNew_CouponLayerSearch({
        couponId: "-100",
        searchResult: "1",
        code: res?.msg || "-100",
        batchId: "-100",
        use_threshold: "-100",
        couponType: "-100" as any,
        couponSave: "-100"
      })
    } else {
      setCodeError("");
      const { data } = res;

      sendClickTrack.SettleAccounts_OrderNew_CouponLayerSearch({
        couponId: "-100",
        searchResult: "0",
        code: "-100",
        batchId: "-100",
        use_threshold: data.quota ? String(data.quota) : "-100",
        couponType: data.type ? String(data.type) as any : "-100",
        couponSave: data.discount ? String(data.discount) : "-100"
      })
    
      // 默认选中口令券
      setCodeCheck(true);
      const params = {
        orderStr: {
          couponCode: applyCode,
          selected: true,
        },
        ...FEACH_PARAMS,
        immediatelyBuy: props.immediatelyBuy,
      };


      const [err, resCode] = await to(fetchuseOrCancelCouponCode(params));

      if (resCode?.resultCode !== "C-DM@60-CD@1.100000") {
        UKToast.show({
          content: resCode.msg,
          icon: "error",
        });
      } else {
        setCodeDetail([{
          ...data,
          selected: true,
          couponType: res.data.type,
        }]);

        const { floors } = resCode.data;
        dealResDate(floors);
        // 通知主页刷新 todo
        props?.onFresh!({
          type: "code",
          data: null,
          refreshOrderSource: "saveCoupon",
        });
      }
    }
  };
  // 单个 - 选中、取消优惠券 (口令券和优惠券二选一)
  const handdleCancelCoupon = async (
    event: React.MouseEvent<Element, MouseEvent>,
    item: couponItems,
  ) => {
    /*
    /* 1、选中优惠券 取消选中的口令券 
    /* 2、取消优惠券 (判断是否同时有其它选中的优惠券)
    /*  2-1 无选中的优惠券 
    /*    a  有口令券 默认选中口令券
    /*    b  无口令券 直接取消优惠
    /*  2-2  有选中的优惠券 直接取消优惠券
    */
    const target = event.target as HTMLInputElement;
    const { checked } = target;
    const { selected, key, id } = item;
    const params = {
      orderStr: {
        useBestCoupon: USERBESTCOUPON, // 是否展示‘使用最优推荐’按钮
        id,
        key,
        selected: !selected,
      },
      ...FEACH_PARAMS,
      immediatelyBuy: props.immediatelyBuy,
    };
    searchancelCoupon(params);
  };
  const handleCardToggleChange = (flag: string, item: any, key: number) => {
    setCurrentKey(key);
    setCurrentId(item.id);
    setIsCardOpen(flag);
    if (flag === "expanddown") {
      if (isOpen === "expand") {
        setCurrentHeight("108px");
      }
      if (isOpen === "close") {
        setCurrentHeight("auto");
      }
    }
    if (flag === "closeup") {
      if (isOpen === "expand") {
        setCurrentHeight("140px");
      }
      if (isOpen === "close") {
        setCurrentHeight("auto");
      }
    }
  };
  // 渲染优惠券卡片
  const couponCardRender = (item: couponItems, key: number, type: string) => {
    return (
      <div
        className={`coupon-card ${type === "available" ? (item.couponType !== 2 ? "off_type" : "free_type") : "nouse_type"}`}
        key={JSON.stringify(item)}
      >
        {type === "available" && item.label ? (
          <span className="label-icon">{item.label ? item.label : ""}</span>
        ) : null}

        <div className="coupon-content-wrap">
          {type === "available" ? (
            <Radio
              sx={{
                color: "#E0E1E5",
              }}
              checked={item.selected}
              className="coupon-check-reset"
              onClick={(event: any) => {
                handdleCancelCoupon(event, item);
                sendClickTrack.SettleAccounts_OrderNew_Coupon({
                  text: "-100",
                  isCoupon: "1",
                  couponId: item.id || "-100",
                  batchId: item.batchId ? String(item.batchId) : "-100",
                  use_threshold: item.quota ? String(item.quota) : "-100",
                  couponType: item.couponType ? String(item.couponType) as any : "-100",
                  couponSave: item.discount || "-100",
                })
              }}
            />
          ) : null}
          <div className="coupon-box">
            <div className="coupon-info">
              {item.couponType !== 2 ? (
                <div>
                  <span className="coupon-off-big">{item.discountStr} </span>
                  <span className="coupon-off-small small-data ml4 mr12">Off</span>
                  {item?.quota && Number(item.quota) ? (
                    <span className="coupon-off-small small-data relative-bottom">
                      {" "}
                      {t("checkout.paymentDetail.over")} {item.quotaStr}
                    </span>
                  ) : null}
                  <p className="coupon-off-limit coupon-off-border info-color margin0">
                    {t("checkout.paymentDetail.validityUntil")} {item.timeEnd}
                  </p>
                </div>
              ) : (
                <div>
                  <span className="coupon-off-big">£{item.discount} </span>
                  <span className="coupon-off-small small-data mr">{t("checkout.paymentDetail.shippingOff")}</span>
                  <p className="coupon-off-limit coupon-off-border info-color margin0">
                  {t("checkout.paymentDetail.validityUntil")}  {item.timeEnd}
                  </p>
                </div>
              )}
            </div>
            <div className={`coupon-content ${item.id === currentId ? isCardOpen : ""}`}>
              <div className="coupon-content-text">
                {item.couponType !== 2 ? (
                  <>
                    <p
                      className={`coupon-off-limit limit-color margin0 ${isCardOpen === "expanddown" ? "coupon-off-ellipsis" : ""}`}
                    >
                      {item.couponLimitInfo}
                    </p>
                    <p className="coupon-off-limit limit-color margin0">{t("checkout.paymentDetail.code")}: {item.id}</p>
                  </>
                ) : (
                  <p className="coupon-off-limit limit-color margin0">{t("checkout.paymentDetail.limit")}</p>
                )}
              </div>
              {item.couponType !== 2 &&
                (currentId === item.id && isCardOpen === "closeup" ? (
                  <CouponClose
                    className="more-icon"
                    onClick={() => handleCardToggleChange("expanddown", item, key)}
                  />
                ) : (
                  <More
                    className="more-icon"
                    onClick={() => handleCardToggleChange("closeup", item, key)}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    getOrderDetails();
  }, [selected]);
  useEffect(() => {
    console.log("来自主页的通知=======", props.actionType);
    if (
      props.actionType?.includes(ACTION_TYPE.ADDRESS) ||
      props.actionType?.includes(ACTION_TYPE.CART)
    ) {
      if (applyCode) {
        updateApplyCode("");
        setCodeCheck(false);
        setCodeDetail([]);
      }
      setSelected("available");
      getOrderDetails();
    }
  }, [props.actionType]);
  const handleKeyPress = (event: any) => {
    const allowedChars = /[a-zA-Z0-9]/;
    if (
      !allowedChars.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      event.key !== "Enter"
    ) {
      event.preventDefault();
    }
  };
  const handleCompositionEnd = (e: any) => {
    const chineseChars = /[^a-zA-Z0-9]/g;
    const value = e.target.value;
    if (chineseChars.test(value)) {
      const newValue = value.replace(chineseChars, "");
      if (newValue !== applyCode) {
        updateApplyCode(newValue);
      }
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value && /^[A-Za-z0-9]+$/.test(e.target.value)) {
      // setCodeError('');
      updateApplyCode(e.target.value);
    } else {
      updateApplyCode("");
    }
  }
  return (
    <div className="apply-coupon-box checkout-apply">
      {/* 标题 */}
      <div className="applay-title">
        <h1 className="applay-title-text">{t("checkout.paymentDetail.applyCoupon")}</h1>
        <div className="applay-title-tab-box">
          <Button
            size="small"
            className={`tab-style tab-left ${selected === "available" ? "selected" : "unselected"}`}
            onClick={() => handleTabChange("available")}
          >
            {t("checkout.common.available")}
          </Button>
          <Button
            size="small"
            className={`tab-style tab-right ${selected === "notavailable" ? "selected" : "unselected"}`}
            onClick={() => handleTabChange("notavailable")}
          >
            {t("checkout.common.noAvailable")}
          </Button>
        </div>
      </div>
      {/* 提示 */}
      {selected === "available" ? (
        <div className="alert-mar">
          <Alert severity="warning">
            {t("checkout.tips.couponsStackedRule")}
          </Alert>
        </div>
      ) : null}

      {/* 申请表 */}
      {selected === "available" ? (
        <div>
          <div className="apply-form">
            <FormControl margin="normal" sx={{ width: "738px" }}>
              <InputLabel sx={{ color: "#505259" }}>{t("checkout.paymentDetail.applyCode")}</InputLabel>
              <FilledInput
                // className="apply-form-input"
                sx={{ background: "#F7F8FC", borderRadius: "4px", height: "48px" }}
                value={applyCode}
                type="text"
                onChange={handleCodeChange}
                onCompositionEnd={handleCompositionEnd}
                inputProps={{
                  onKeyPress: handleKeyPress,
                }}
                endAdornment={
                  <InputAdornment position="end">
                    {applyCode ? (
                      <>
                        <IconButton
                          onClick={(e) => {
                            handleCodeChange(e as any)
                          }}
                        >
                          <Closed />
                        </IconButton>
                      </>
                    ) : null}
                  </InputAdornment>
                }
              />
              {codeError && (
                <FormHelperText sx={{ color: "#FF0F23", margin: "0" }}>
                  <div className="input-error">
                    <span>{codeError}</span>
                  </div>
                </FormHelperText>
              )}
            </FormControl>
            <Button
              variant="contained"
              size="large"
              onClick={handleSearchApplyCode}
            >
              {t("checkout.common.apply")}
            </Button>
          </div>
          {codeDetail?.length > 0 && codeDetail[0].discountStr ? (
            <div className="apply-code-box">
              <div className="apply-code-check">
                <Radio
                  sx={{
                    color: "#E0E1E5",
                  }}
                  checked={codeDetail[0]?.selected}
                  onClick={(event: any) => {
                    handleUseOrCancelCouponCode(event);
                    const item = codeDetail[0];
                    sendClickTrack.SettleAccounts_OrderNew_Coupon({
                      text: "-100",
                      isCoupon: "1",
                      couponId: item.id || "-100",
                      batchId: item.batchId ? String(item.batchId) : "-100",
                      use_threshold: item.quota ? String(item.quota) : "-100",
                      couponType: item.couponType ? String(item.couponType) as any : "-100",
                      couponSave: item.discount || "-100",
                    })
                  }}
                />
                {/* <Checkbox className="coupon-check-reset" onClick={handleRadioChange} /> */}
                {/* 满减券  quota discount */}
                <span className="coupon-off-big ml5 red">{codeDetail[0]?.discountStr} </span>
                <span className="coupon-off-small red flex-bottom ml5 mr12">Off</span>
                {/* {codeCouponDetail?.quota > 0 ? (
                  <span className="coupon-off-small red"> over {codeCouponDetail?.quota}</span>
                ) : null} */}
                {codeDetail[0]?.quota ? (
                  <span className="coupon-off-small red flex-bottom relative-bottom">
                    {" "}
                    {t("checkout.paymentDetail.over")} {codeDetail[0]?.quotaStr}
                  </span>
                ) : null}
              </div>
              {/* <span className="gray font12">Code: {codeDetail?.promoCode}</span> */}
            </div>
          ) : null}
        </div>
      ) : null}
      {/* 优惠券列表 */}
      {currentData?.length ? (
        // <div className={`checkout-coupon-card-box ${isOpen}-h`} style={{height:currentHeight}}>
        <div className={`checkout-coupon-card-box`} style={{ height: currentHeight }}>
          {currentData.map((item, key) => couponCardRender(item, key, selected))}
        </div>
      ) : codeDetail?.length ? null : (
        <NoCouponData msg={t("checkout.paymentDetail.noAvailable")} />
      )}
      {/* 展开 收起 */}
      {currentData?.length > 2 ? (
        <div className={`toggle-box  ${isOpen}`} onClick={handleToggleChange}>
          <span>{isOpen === "expand" ? "View more" : "Retract"} </span>
          {isOpen === "expand" ? (
            <Expand className="toggle-icon" stroke="red" />
          ) : (
            <CloseIcon className="toggle-icon" stroke="red" />
          )}
        </div>
      ) : null}
    </div>
  );
}
